import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';

import { DOCUMENT_COLLABORATION } from '../../constants/Urls';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';
import ControlChangesIcon from '../components/ControlChangesIcon';
import { FORM_MODEL_ATTRIBUTES } from '../constants/form-manager.constants';
import { FCM_BUTTON_STYLES } from '../constants/runtime.constants';
import { getWorkflowInfo } from '../selectors/common.selectors';
import { getEvaluatedExpression } from '../selectors/form-manager.selectors';

const buttonLabelMap = {
  COLLABORATOR: 'Collaborate in Office',
  DOCUMENTOWNER: 'Edit in Office',
};

const useStyles = makeStyles(FCM_BUTTON_STYLES);

function SSButtonOfficeOnline({
  id,
  index,
  entityName,
  isEditor,
  isControlHiddenFCM,
  isControlAddedFCM,
  isControlChangedFCM,
}) {
  const classes = useStyles({ isControlAddedFCM });
  const translateString = useTranslation();
  const { itmId, workflowId, stepId } = useFormSelector(getWorkflowInfo);
  const documentUser = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    entityName,
    prop: FORM_MODEL_ATTRIBUTES.OFFICE_ONLINE_OPTIONS,
  });
  const [url, setUrl] = useState(null);

  useEffect(() => {
    const params = qs.stringify(
      {
        entityType: 'SDC_DOCUMENT',
        formKey: 'SDC_DOCUMENT_DETAIL',
        documentUser,
        workflowId,
        stepId,
        itmId,
      },
      { encode: false }
    );

    setUrl(`${DOCUMENT_COLLABORATION}?${params}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickHandler = () => window.open(url.substr(1));

  return (
    <span
      className={isControlAddedFCM || isControlChangedFCM ? classes.changesModeWrapper : null}
      ui-ta={getUITA('FormCtrl', 'SSButtonOfficeOnline')}
      data-ss-id={id}
    >
      <Button
        color="primary"
        variant="secondary"
        style={{ minWidth: '128px' }}
        onClick={onClickHandler}
        disabled={isEditor || isControlHiddenFCM}
      >
        {translateString(buttonLabelMap[documentUser] || 'Office Online')}
      </Button>
      {isControlChangedFCM && (
        <span className={classes.changesIcon}>
          <ControlChangesIcon id={id} />
        </span>
      )}
    </span>
  );
}

export default SSButtonOfficeOnline;
